<template>
  <div
    ref="containerRef"
    :class="['dropdown-container', containerClass, disabled ? 'disabled' : '']"
    :style="[containerStyle]"
  >
    <template v-if="$slots.default">
      <slot></slot>
    </template>
    <div v-else>
      <input
        v-model="inputDropdown"
        :readonly="!isInput"
        :class="['input-dropdown']"
        :placeholder="placeholder"
      />
    </div>
    <div
      ref="contentRef"
      v-show="isOpen"
      class="dropdown-content"
      :style="[contentStyle]"
    >
      <template v-if="options?.length">
        <div
          v-for="item in options" :key="item"
          :class="['item', finalValue === item.value ? 'active' : '']"
          @click="handleOnChange(item)"
        >
          {{ item.label }}
        </div>
      </template>
      <div v-else>
        <div
          class="item empty"
        >
          No Options
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from "lodash"
export default {
  props: {
    containerStyle: Object,
    containerClass: String,
    contentStyle: Object,
    options: Array,
    value: [Object, String],
    isInput: Boolean,
    loading: Boolean,
    disabled: [Boolean, String],
    placeholder: {
      type: String,
      default: "Select an Option",
    },
  },
  data() {
    return {
      inputDropdown: "",
      isOpen: false,
    };
  },
  computed: {
    finalLabel() {
      if (typeof this.value == "string") {
        let findOption = this.options?.find(
          (option) => option.value === this.value
        );
        return findOption?.label || this.inputDropdown;
      }
      return this.value?.label || this.inputDropdown;
    },
    finalValue() {
      if (typeof this.value == "string") {
        return this.value || this.inputDropdown;
      }
      return this.value?.value || this.inputDropdown;
    },
  },
  watch: {
    finalLabel() {
      this.inputDropdown = this.finalLabel;
    },
    inputDropdown(val){
      if(val) this.isOpen = true;
      this.handleInputChange(val)
    },
    // watch if props value become empty, empty the local also
    value(val){
      if(!val){
        this.inputDropdown = ""
      }
    },
    // watch isOpen to make sure reset for both props and local.
    // if local have value but the props dont, empty local
    isOpen(){
      if(!this.isOpen && !this.value){
        this.inputDropdown = ""
      }
    }
  },
  methods: {
    handleClick(event) {
      let currentRef = this.$refs.containerRef;
      if (currentRef.contains(event.target)) {
        if (!this.isOpen) {
          this.isOpen = true;
        } else if (
          this.isOpen &&
          (!this.inputDropdown || !this.isInput) &&
          currentRef.children[0].contains(event.target)
        ) {
          this.isOpen = false;
        }
      } else if (!currentRef.contains(event.target)) {
        this.isOpen = false;
      }
    },
    handleScroll() {
      const el = this.$refs.contentRef;
      let calc =
        (el && Math.floor(el.scrollHeight - el.scrollTop - el.clientHeight)) ||
        0;

      if (el && calc <= 0 && !this.loading) {
        // console.log("HIT BOTTOM SCROLL");
        // create function eg: onBottomEnd from props
      }
    },
    handleOnChange(value) {
      this.$emit("onChange", value);
      this.isOpen = false;
    },
    handleInputChange: lodash.debounce(function(value) {
      this.$emit("onInputChange", value);
    }, 1000)
  },
  mounted() {
    document.addEventListener("mousedown", this.handleClick, {
      passive: true,
    });
    this.$refs.contentRef &&
      this.$refs.contentRef.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    document.removeEventListener("mousedown", this.handleClick);
    this.$refs.contentRef &&
      this.$refs.contentRef.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.dropdown-container {
  position: relative;
  display: flex;
  user-select: none;
  cursor: pointer;
  
  &.disabled{
    pointer-events: none;
    opacity: 0.5;
  }

  .dropdown-content {
    overflow: auto;
    max-height: 160px;
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #ffffff;
    top: calc(100% + 3px);
    left: -1px;
    z-index: 2;
    box-sizing: content-box;
    border: thin solid #fdd1d4;
    border-radius: 6px;
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.08);

    .item {
      text-align: start;
      padding: 8px;
      &.active {
        background-color: #f3f2f8;
      }
      &:hover {
        background-color: #f3f2f8;
      }
      &.empty {
          &:hover {
          background-color: transparent;
          cursor: default;
        }
      }
    }
  }

  .input-dropdown {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    border: thin solid #fdd1d4;
    border-radius: 8px;
    padding: 0 16px;
    min-width: 150px;
    width: 100%;
    height: 40px;
    font-weight: 700;
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.08);
    user-select: none;
    cursor: pointer;
    outline: none;
  }
}
</style>
